import React from 'react';
import { Container, Typography,Button, Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import useStyles from '../../styles/cartStyles';
import CartItem from './CartItem/Cartitem';

const Cart = ({cart,handleUpdateCartQTY, handleEmptyCart, handleRemoveFromCart}) => {
    const classes = useStyles();

    const EmptyCart = () => {
        return (
        <Typography variant="subtitle1">
       Your Cart Is Empty<Link to="/" className={classes.link}> Start Adding Something!</Link>
        </Typography>
        )
    }

    const FilledCart = () => {
        return (
        <>
        <Grid container spacing={3}>
        {cart.line_items.map((item) => (
            <Grid item xs={12} sm={4} key={item.id}>

                <CartItem item={item} onUpdateCartQTY = {handleUpdateCartQTY} onRemoveFromCart={handleRemoveFromCart} />
            </Grid>

        ))}
        </Grid>
        <div className={classes.cardDetails}>

      <Typography variant="h5">
        Subtotal: {cart.subtotal.formatted_with_symbol}
      </Typography>
             <div>
                <Button className={classes.emptyButton} size="large" type="button" variant="contained" color="secondary" onClick={handleEmptyCart}>
                 Empty Cart
                </Button>
                <Button component={ Link } to="/checkout" className={classes.checkoutButton} size="large" type="button" variant="contained" color="primary">
                CheckOut
                </Button>
             </div>
        </div>
        </>
        )
    };

    if(!cart.line_items) return "Loading...";
    

  return (
    <Container>
        <div className={classes.toolbar} />
        <Typography className={classes.title} variant="h4" gutterBottom>

       Your Shopping Cart

        </Typography>

        { !cart.line_items.length ? <EmptyCart/> : <FilledCart/> }
    </Container>
  )
}

export default Cart;